import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { createFeatureFlag, fetchFeatureFlags } from "../app/actions";
import { withRouter } from "react-router-dom";
import { Button, Table } from "react-bootstrap"
import AddEditFeatureFlagModal from "./AddEditFeatureFlagModal";


const FeatureFlags = ({history}) => {

    const featureFlags = useSelector(store => store.app.featureFlags);
    const dispatch = useDispatch();
    const [showAddEditModal, setShowAddEditModal] = useState(false)

    useEffect(()=>{
        dispatch(fetchFeatureFlags())
    }, [])

    const goToFeatureFlag = id => {
        history.push("/feature-flags/"+id)
    }

    const hideAddEditModal = () => {
        setShowAddEditModal(false)
    }

    const handleSave = (featureFlag) => {

        dispatch(createFeatureFlag(
            featureFlag.Active,
            featureFlag.FeatureName,
            featureFlag.FeatureDescription,
            featureFlag.PricePerMonth
        )).then(()=>{
            dispatch(fetchFeatureFlags())
            setShowAddEditModal(false)
        })
    }
    
    return <div>
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
            <h2>Feature flags</h2>
            <Button onClick={()=> setShowAddEditModal(true)}>Create feature flag</Button>
        </div>
        <br/>
        <Table striped bordered hover>
            <thead>
                <tr>
                    <th>#</th>
                    <th>Active</th>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Price per month</th>
                    <th>Updated</th>
                    <th>Created</th>
                </tr>
            </thead>
            <tbody>
                {featureFlags && featureFlags.map(featureFlag => {
                    return <tr key={featureFlag.id} onClick={()=> goToFeatureFlag(featureFlag.id)}>
                        <td>{featureFlag.id}</td>
                        <td>{featureFlag.Active}</td>
                        <td>{featureFlag.FeatureName}</td>
                        <td>{featureFlag.FeatureDescription}</td>
                        <td>{featureFlag.PricePerMonth}</td>
                        <td>{featureFlag.updated_at}</td>
                        <td>{featureFlag.created_at}</td>
                    </tr>
                })}
                
            </tbody>
        </Table>
        <AddEditFeatureFlagModal editFeatureFlag={null} show={showAddEditModal} onHide={hideAddEditModal} onSave={handleSave} />
    </div>
} 

export default withRouter(FeatureFlags)